import React from 'react';
import Footer from '../../components/Footer';
import Navlite from "../../components/NavLite"
import GoogleMeSis from "../../assets/GoogleMe.png"; // Import your image

function PlayBook() {
  return (

    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1 ]">
    <title> The Visibility Playbook | Web Strategy for Women Entrepreneurs | Her Growth Co.</title>
<meta
name="description"
content="Get access to Her Growth Co’s Visibility Playbook—a strategic resource for building a powerful online presence for your women-led brand."
/>
<meta
name="keywords"
content="female founder business playbook, digital growth strategy for women, website planning for women entrepreneurs, step-by-step online growth guide, DIY marketing strategy for women-led brands, authority-building playbook, smart systems for sustainable growth, visibility strategy workbook, content marketing austin, seo blog strategy for women, thought leadership content austin, content writing for consultants, austin content creation services, blogging for female-led businesses, digital content strategy texas, content marketing for premium brands, blog calendar seo strategy, lead magnet development, content writing agency austin, long-form content for seo, women entrepreneurs blog writers, austin business blogging experts, social content integration austin, texas content marketing agency, content creation for service businesses, copywriting for niche businesses, content for authority websites, seo copywriting austin, blog content for lead generation, austin content funnel building, content upgrades for coaches, expert content planning texas, personal brand content writing"
/>
    <div className='bg-[#2E2D2B]'>
   <Navlite/>
   
      <section>
        <div
          style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 90%, 0 100%)',
            backgroundColor: '#2E2D2B',
            padding: '20px',
            width: '100%',
          }}
        >
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="grid items-center gap-8 sm:gap-20 md:grid-cols-2">
              <div className='max-w-[450px]'>
                <h2 className="mb-4 text-3xl font-bold md:text-4xl md:leading-snug">
                  GOOGLE RANKING <span className='italic text-black bg-[#CFF098]'>PLAYBOOK</span> COMING SOON!
                </h2>
                <p className="mb-6 max-w-lg text-sm text-white sm:text-base md:mb-8 font-light">
                  Stay tuned! Our comprehensive Playbook, filled with the secrets our SEO specialists use to rank our clients' #1 on Google, is coming soon. Get ready to elevate your online presence and drive unparalleled success.
                </p>
                {/* Remove the purchase button since it's coming soon */}
                {/* <a href='/playbook'>
                  <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">Purchase Playbook</button>
                </a> */}
                <script async
  src="https://js.stripe.com/v3/buy-button.js">
</script>

<stripe-buy-button
  buy-button-id="buy_btn_1RAhboKipJd0v0FJduFDAfwi"
  publishable-key="pk_live_51RAHntKipJd0v0FJtbwOB0iesBrvWrbKzKzD4tRWrQpopUohiIZY3awYtdAOjsJTOBp9lPpEdHBeM0KUAjBWYI9K00NU7OMVpH"
>
</stripe-buy-button>
              </div>
              
              <div>
                <img src={GoogleMeSis} alt="Google Ranking Playbook - Her Growth Co" className="mx-auto inline-block h- w-[450px] max-w-2xl" />
              </div>
            </div>
          </div>
        </div>
        
      </section>
      <Footer />
    </div>
    </main>
  );
}

export default PlayBook;